import type { Database } from '@here/api'

export const getpatternSpecification = (
	high_1_price: number,
	low_1_price: number,
	axis3: number,
	isLong: boolean,
): Database['public']['Enums']['pattern_specification'] => {
	let slungRange = isLong
		? ((axis3 - low_1_price) / (high_1_price - low_1_price)) * 100
		: ((axis3 - low_1_price) / (high_1_price - low_1_price)) * 100
	// : ((high_1_price - axis3) / (high_1_price - low_1_price)) * 100;

	// if (!isLong) {
	// 	slungRange = 100 - slungRange;
	// }

	slungRange = Math.round(slungRange * 100) / 100

	console.log(slungRange)

	return isLong ? checkLongFib(slungRange) : checkShortFib(slungRange)
}

const checkLongFib = (slungRange: number) => {
	if (slungRange <= 100 && slungRange > 78.6) {
		return 'extremely-high-slung'
	}

	if (slungRange <= 78.6 && slungRange > 61.8) {
		return 'high-slung'
	}

	if (slungRange <= 61.8 && slungRange > 50) {
		return 'broadly-symmetrical-high-side'
	}

	if (slungRange === 50) {
		return 'perfectly-symmetrical'
	}

	if (slungRange < 50 && slungRange > 38.2) {
		return 'broadly-symmetrical-low-side'
	}

	if (slungRange <= 38.2 && slungRange > 23.6) {
		return 'low-slung'
	}

	return 'extremely-low-slung'
}

const checkShortFib = (slungRange: number) => {
	if (slungRange <= 100 && slungRange > 78.6) {
		return 'extremely-low-slung'
	}

	if (slungRange <= 78.6 && slungRange > 61.8) {
		return 'low-slung'
	}

	if (slungRange <= 61.8 && slungRange > 50) {
		return 'broadly-symmetrical-low-side'
	}

	if (slungRange === 50) {
		return 'perfectly-symmetrical'
	}

	if (slungRange < 50 && slungRange > 38.2) {
		return 'broadly-symmetrical-high-side'
	}

	if (slungRange <= 38.2 && slungRange > 23.6) {
		return 'high-slung'
	}

	return 'extremely-high-slung'
}
